import { createContext } from 'react';

export const DialogContext = createContext<{ invert?: boolean }>({
  invert: false,
});
